export class HistServiceStaticVariable{
    static EnableFreqFree = true;
}